import React, { useState, useEffect } from 'react'
import { initializeApp } from "firebase/app"
import axios from 'axios'
import html2canvas from "html2canvas"
import { jsPDF } from "jspdf"

import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import FloatingLabel from 'react-bootstrap/FloatingLabel'
import Navbar from 'react-bootstrap/Navbar'
import Nav from 'react-bootstrap/Nav'

import { ReactComponent as SpartekII } from './img/SPARTEK.svg'
import { ReactComponent as SpartekIII } from './img/SPARTEKIII.svg'
import { ReactComponent as ACUPARK } from './img/ACUPARKI.svg'
import { ReactComponent as ACUPARKII } from './img/ACUPARK.svg'
import { ReactComponent as ACUPARKIII } from './img/ACUPARKIII.svg'
import { ReactComponent as NORTE } from './img/NORTE.svg'
import { ReactComponent as ACTITEK } from './img/ACTITEK.svg'
import { ReactComponent as SITAPARK } from './img/SITAPARK.svg'

import logo from './img/LOGO.png'
import logo_b from './img/logo_b.png'
import star from './img/star.png'
import header from './img/header.png'

import 'bootstrap/dist/css/bootstrap.min.css'
import './App.css';

const firebaseConfig = {
  apiKey: "AIzaSyB-fnPhAuDUlRhq4Hm3ARtKUgZ4ynCTu3w",
  authDomain: "sph-planos.firebaseapp.com",
  databaseURL: "https://sph-planos-default-rtdb.firebaseio.com",
  projectId: "sph-planos",
  storageBucket: "sph-planos.appspot.com",
  messagingSenderId: "464047300814",
  appId: "1:464047300814:web:a725f6c1dfe2ee0b6e709f"
};
const app = initializeApp(firebaseConfig);

const formatoMXN = new Intl.NumberFormat('es-MX', {
  style: 'currency',
  currency: 'MXN',
});

//const API_PATH = 'https://sph-planos-default-rtdb.firebaseio.com/spartek.json'
const API_PATH = 'https://sph-planos-default-rtdb.firebaseio.com/'

function App() {
  const [show, setShow] = useState()
  const [showMessage, setShowMessage] = useState()
  const [messageTitle, setMessageTitle] = useState('')
  const [messageBody, setMessageBody] = useState('')
  const [signed, setSigned] = useState(false)
  const [showToast, setShowToast] = useState(false)
  const [date, setDate] = useState()
  const [offer, setOffer] = useState('renta')
  const [park, setPark] = useState('SPARTEK')

  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")

  const [idHtml, setIdHtml] = useState("")
  const [id, setId] = useState("")
  const [el, setEl] = useState("")
  const [status, setStatus] = useState("")
  const [statusRent, setStatusRent] = useState("")
  const [name, setName] = useState("")
  const [mza, setMza] = useState("")
  const [lte, setLte] = useState("")
  const [land, setLand] = useState("")
  const [build, setBuild] = useState("")
  const [type, setType] = useState("")
  const [rent, setRent] = useState("")
  const [price, setPrice] = useState('')
  const [delivery, setDelivery] = useState('')
  const [building, setBuilding] = useState('')
  const [inBuild, setInBuild] = useState('')

  const [priceConst, setPriceConst] = useState("")
  const [priceMant, setPriceMant] = useState("")
  const [priceRent, setPriceRent] = useState("")
  const [totalRent, setTotalRent] = useState("")

  useEffect(() => {
    handleOnSubmit()

    const allWithClass = Array.from(
      document.getElementsByClassName('st48')
    );

    allWithClass.map(item => {
      item.addEventListener("click", () => testfunction(item));
    })

    var event = new Date();
    var options = { year: 'numeric', month: 'long', day: 'numeric' };
    setDate(event.toLocaleDateString('es-ES', options))
  }, []);

  useEffect(() => {
    handleOnSubmit()
    var classes = null

    if (park == 'SPARTEK' || park == 'ACUPARK III') {
      classes = document.getElementsByClassName('st90a')
    } else if (park == 'NORTE') {
      classes = document.getElementsByClassName('st23')
    } else if (park == 'SPARTEK III') {
      classes = document.getElementsByClassName('st0a')
    } else if (park == 'ACTITEK' || park == 'ACUPARK') {
      classes = document.getElementsByClassName('st7')
    } else if (park == 'SITAPARK') {
      classes = document.getElementsByClassName('st6')
    } else {
      classes = document.getElementsByClassName('st36a')
    }

    const allWithClass = Array.from(classes);

    allWithClass.map(item => {
      item.addEventListener("click", () => testfunction(item));
    })
  }, [park]);

  useEffect(() => {
    handleOnSubmit()
  }, [offer]);

  const testfunction = (e) => {
    setShow(true)

    setEl(e.dataset.element);
    setIdHtml(e.dataset.idhtml)
    setId(e.dataset.simpleid)
    setName(e.dataset.nombre)
    setLand(e.dataset.land)
    setBuild(e.dataset.build)
    setMza(e.dataset.mza)
    setLte(e.dataset.lte)
    setType(e.dataset.tipo)
    setStatus(e.dataset.estatus)
    setStatusRent(e.dataset.estatusrent)
    setRent(e.dataset.rent && e.dataset.rent != 'undefined' ? e.dataset.rent : "N/A")
    setPrice(e.dataset.price)
    setDelivery(e.dataset.delivery)
    setBuilding(e.dataset.building)
    setInBuild(e.dataset.building)

    setPriceConst(e.dataset.priceconst)
    setPriceMant(e.dataset.pricemant)
    setPriceRent(e.dataset.pricerent)
    setTotalRent(e.dataset.totalrent)
  }

  const removeClasses = (element, second, rent) => {
    element?.classList?.remove?.("nbh-purpple");
    element?.classList?.remove?.("nbh-orange");
    element?.classList?.remove?.("nbh-red");
    element?.classList?.remove?.("nbh-blue");
    element?.classList?.remove?.("nbh-green");
    element?.classList?.remove?.("nbh-green-b");
    element?.classList?.remove?.("nbh-green-c");
    element?.classList?.remove?.("nbh-yellow");
    element?.classList?.remove?.("nbh-brown");
    element?.classList?.remove?.("nbh-gray");

    element?.classList?.remove?.("nbs-red");
    element?.classList?.remove?.("nbs-gray");

    second?.classList?.remove?.("hide");
    rent?.classList?.remove?.("hide");
  }

  const handleOnSubmit = (token) => {

    axios.get(API_PATH + (park == 'ACUPARK II' ? 'acupark.json' : (park == 'ACUPARK' ? 'acuparki.json' : park.toLowerCase().replaceAll(' ', '') + '.json')), {}, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(function (response) {
      const elements = response.data
      //console.log("response", response)

      elements.map((element, index) => {
        const svgPrincipal = document.getElementById(`${element.IdHtml}p`);
        const svgCloned = document.getElementById(`c${element.IdHtml}p`);
        const svgSecond = document.getElementById(`e${element.IdHtml}p`);
        const svgRent = document.getElementById(`i${element.IdHtml}p`);
        removeClasses(svgPrincipal, svgSecond, svgRent)
        /*if (element.Estatus == 1) {
          if( offer == 'venta') svgPrincipal?.classList?.add?.("nbh-green");
        } else if (element.Estatus == 3) {
          if( offer == 'venta' ) svgPrincipal?.classList?.add?.("nbh-blue");
        } else if (element.Estatus == 2) {
          if( offer == 'renta') svgPrincipal?.classList?.add?.("nbh-green");
          //if( offer == 'venta') svgPrincipal?.classList?.add?.("nbs-red");
        } else if (element.Estatus == 4) {
          if( offer == 'renta') svgPrincipal?.classList?.add?.("nbh-blue");
        } else if (element.Estatus == 5) {
          if( offer == 'renta') svgPrincipal?.classList?.add?.("nbh-red");
        }*/

        if (offer == 'venta') {
          if (element.Estatus == 1)
            svgPrincipal?.classList?.add?.("nbh-green");
          else if (element.Estatus == 3)
            svgPrincipal?.classList?.add?.("nbh-blue");
          else if (element.Estatus == 0 || element.Estatus == 6)
            svgPrincipal?.classList?.add?.("nbh-red");
          else if (element.Estatus == 7)
            svgPrincipal?.classList?.add?.("nbh-gray");

          /*if ((element.Estatus == 0 || element.Estatus == 2 || element.Estatus == 4 || element.Estatus == 5) && element.investor != '-') {
            svgPrincipal?.classList?.add?.("nbh-red");
          }*/

          /*if(element.ForceAvailable == true){
            svgPrincipal?.classList?.add?.("nbh-green");
          }*/
        }

        if (offer == 'renta') {
          if (element.EstatusRent == 2)
            svgPrincipal?.classList?.add?.("nbh-green");
          else if (element.EstatusRent == 4)
            svgPrincipal?.classList?.add?.("nbh-blue");
          else if (element.EstatusRent == 5)
            svgPrincipal?.classList?.add?.("nbh-red");
          else if (element.EstatusRent == 8)
            svgPrincipal?.classList?.add?.("nbh-gray");
          else if (element.EstatusRent == 9)
            svgPrincipal?.classList?.add?.("nbh-orange");

          /*if (element.rent != '-') {
            svgPrincipal?.classList?.add?.("nbh-red");
          }*/
        }
        /*else if (element.Estatus == 4)
          svgPrincipal?.classList?.add?.("nbh-blue");
        else if (element.Estatus == 5)
          svgPrincipal?.classList?.add?.("nbh-green");
        else if (element.Estatus == 6)
          svgPrincipal?.classList?.add?.("nbh-yellow");
        else
          svgPrincipal?.classList?.add?.("nbh-brown");*/

        svgCloned?.setAttribute("data-idhtml", (element.IdHtml).toString());
        svgCloned?.setAttribute("data-simpleid", element.id);
        svgCloned?.setAttribute("data-element", index);
        svgCloned?.setAttribute("data-estatus", element.Estatus);
        svgCloned?.setAttribute("data-estatusrent", element.EstatusRent);
        svgCloned?.setAttribute("data-tipo", (element.Tipo).toString());
        svgCloned?.setAttribute("data-land", element.Land);
        svgCloned?.setAttribute("data-build", element.Build);
        svgCloned?.setAttribute("data-lte", element.Lte);
        svgCloned?.setAttribute("data-mza", element.Mza);
        svgCloned?.setAttribute("data-nombre", element.Nombre);
        svgCloned?.setAttribute("data-rent", element.rent);
        svgCloned?.setAttribute("data-building", element.inBuild);
        svgCloned?.setAttribute("data-price", element.price);
        svgCloned?.setAttribute("data-delivery", element.delivery);
        svgCloned?.setAttribute("data-office", element.office);

        svgCloned?.setAttribute("data-priceconst", element.priceConst);
        svgCloned?.setAttribute("data-pricemant", element.priceMant);
        svgCloned?.setAttribute("data-pricerent", (element.priceRent).toString());
        svgCloned?.setAttribute("data-totalrent", element.totalRent);

        if (element.inBuild == 'building') {
          //svgSecond?.classList?.add?.("hide");
          svgSecond?.classList?.add?.("on-construction");
          if (offer == 'renta' && element.EstatusRent == 2) {
            svgPrincipal?.classList?.remove?.("nbh-green");
            svgPrincipal?.classList?.add?.("nbh-green-c");
          }
        } else if (element.inBuild == 'coming') {
          svgSecond?.classList?.add?.("coming-soon");
          if (offer == 'renta' && element.EstatusRent == 2) svgPrincipal?.classList?.remove?.("nbh-green");
        } else if (element.inBuild == 'building80') {
          svgSecond?.classList?.add?.("on-construction");
          if (offer == 'renta' && element.EstatusRent == 2) {
            svgPrincipal?.classList?.remove?.("nbh-green");
            svgPrincipal?.classList?.add?.("nbh-green-b");
          }
        } else if (element.inBuild == 'land') {
          svgSecond?.classList?.add?.("on-land");
        } else {
          svgSecond?.classList?.add?.("hide");
          //svgPrincipal?.classList?.add?.("nbs-red");
        }

        if (offer == 'venta' && (element.EstatusRent == 5)) {
          svgRent?.classList?.add?.("show");
          svgRent?.classList?.add?.("st-rent");
        } else
          svgRent?.classList?.add?.("hide");

        //if( offer == 'venta' && element.rent != '-')
        /*if( offer == 'venta' && element.investor == '-' && element.rent != '-')
          svgPrincipal?.classList?.add?.("nbs-blue");
        else  svgPrincipal?.classList?.remove?.("nbs-blue");*/

      })

    }).catch(function (err) {
      console.log("ERROR")
    });
  }

  const downloading = () => {
    setShowToast(true)

    setTimeout(() => {
      printPDF()
    }, 1000);
  }

  const printPDF = () => {
    const infoPageElement = document.getElementById("App");
    const pdf = new jsPDF('p', 'mm', 'a4');
    setShowToast(true)

    html2canvas(infoPageElement, {
      onclone: document => {
        //document.getElementById("print").style.visibility = "hidden";
      },
      scale: 3,
      useCORS: true,
      allowTaint: false
    }).then(canvas => {
      /*var a = document.createElement('a');
      a.href = canvas.toDataURL("image/jpeg").replace("image/jpeg", "image/octet-stream");
      a.download = `${new Date().toISOString()}.jpg`;
      a.click();*/

      pdf.addImage(canvas.toDataURL("image/jpeg"), "JPEG", 5, 5, 200, 288);
      pdf.save(`${new Date().toISOString()}.pdf`);

      /*const imgData = canvas.toDataURL("image/jpeg");
      const pdf = new jsPdf('p', 'mm', 'a4');

      //pdf.addImage(imgData, "JPEG", 10, 10, 297.64, 420.94);
      pdf.addImage(imgData, "JPEG", 10, 10);
      pdf.save(`${new Date().toISOString()}.pdf`);*/
    });

  };

  const reloadPage = () => {
    handleOnSubmit()
    setShowMessage(false)
    //window.location.reload()
  }

  const desformatearDivisa = (valorFormateado, locale = 'es-MX') => {
    const limpio = valorFormateado
      .replace(/[^\d.-]/g, '')
      .replace(',', '');

    return parseFloat(limpio);
  }

  return (
    <div className="App" align="center">
      <Modal show={showToast}>
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            <img src={logo_b} className="logo_b" />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {'Descargando...'}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>Tu Descarga comenzará en breve.</p>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowToast(false)}>Cerrar</Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showMessage}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header onHide={() => setShow(false)}>
          <Modal.Title id="contained-modal-title-vcenter">
            <img src={logo_b} className="logo_b" />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {messageTitle}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>{messageBody}</div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => reloadPage()}>Aceptar</Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={show}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header onHide={() => setShow(false)}>
          <Modal.Title id="contained-modal-title-vcenter">
            <img src={logo_b} className="logo_b" />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {building === 'land' ? 'Lote industrial ' + name.replace('nave ', '') : name}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <Container>
            <Row>
              <Col md={6}>
                {offer == 'venta' &&
                  <FloatingLabel label="Status" className="mb-3" >
                    <Form.Select disabled={true} aria-label="Status" value={status} onChange={(e) => setStatus(e.target.value)}>
                      <option value="0">Sin Estatus</option>
                      <option value="6">Vendida</option>
                      <option value="1">Disponible</option>
                      <option value="3">Apartado</option>
                      <option value="7">Bloqueado</option>
                    </Form.Select>
                  </FloatingLabel>
                }
                {offer == 'renta' &&
                  <FloatingLabel label="Status" className="mb-3" >
                    <Form.Select disabled={true} aria-label="Status" value={statusRent} onChange={(e) => setStatus(e.target.value)}>
                      <option value="0">Sin Estatus</option>
                      <option value="5">Rentada</option>
                      <option value="2">Disponible</option>
                      <option value="4">Apartado</option>
                      <option value="8">Bloqueado</option>
                      <option value="9">Propia</option>
                    </Form.Select>
                  </FloatingLabel>
                }
              </Col>
              <Col md={6}>
                <FloatingLabel label="Estado de construcción" className="mb-3">
                  <Form.Select disabled={true} aria-label="Nave en construcción" value={inBuild} onChange={(e) => setInBuild(e.target.value)}>
                    <option value={'land'} >Terreno</option>
                    <option value={'building'} >En construcción</option>
                    <option value={'building80'} >{"En construcción > 80%"}</option>
                    <option value={'finish'} >Terminado</option>
                    <option value={'coming'} >Por construir</option>
                  </Form.Select>
                </FloatingLabel>
              </Col>
              <Col md={6}>
                <FloatingLabel label="Manzana" className="mb-3">
                  <Form.Control disabled={signed ? false : true} type="text" placeholder="Manzana" value={mza} onChange={(e) => setMza(e.target.value)} />
                </FloatingLabel>

                <FloatingLabel label="Lote" className="mb-3">
                  <Form.Control disabled={signed ? false : true} type="text" placeholder="Lote" value={lte} onChange={(e) => setLte(e.target.value)} />
                </FloatingLabel>

                {offer === 'venta' ?
                  <FloatingLabel label="Precio de contado" className="mb-3">
                    <Form.Control disabled={signed ? false : true} type="text" placeholder="Precio de contado" value={(priceConst && priceConst > 0) ? formatoMXN.format(
                      ((parseFloat((desformatearDivisa(priceConst) * parseFloat(build))) - parseFloat((3000 * parseFloat(land)))) * 1.16) + parseFloat((3000 * parseFloat(land)))) : price
                    } onChange={(e) => setPrice(e.target.value)} />
                  </FloatingLabel>
                  :
                  <FloatingLabel label="Precio de renta" className="mb-3">
                    <Form.Control disabled={signed ? false : true} type="text" placeholder="Precio de renta" value={priceRent ? formatoMXN.format(
                      parseFloat((desformatearDivisa(priceRent) * parseFloat(build)) * 1.16) + parseFloat((desformatearDivisa(priceMant) * parseFloat(build) * 1.16))) : ''
                    } onChange={(e) => setTotalRent(e.target.value)} />
                  </FloatingLabel>
                }

                {offer === 'venta' &&
                  <FloatingLabel label="Precio X M2" className="mb-3">
                    <Form.Control disabled={signed ? false : true} type="text" placeholder="Precio de M2 de Construcción" value={priceConst} onChange={(e) => setPriceConst(e.target.value)} />
                  </FloatingLabel>
                }

                {offer === 'renta' &&
                  <FloatingLabel label="Precio X M2 de Mantenimiento" className="mb-3">
                    <Form.Control disabled={signed ? false : true} type="text" placeholder="Precio de M2 de Mantenimiento" value={priceMant} onChange={(e) => setPriceMant(e.target.value)} />
                  </FloatingLabel>
                }
              </Col>
              <Col md={6}>
                <FloatingLabel label="Terreno ( m2 )" className="mb-3">
                  <Form.Control disabled={signed ? false : true} type="text" placeholder="Terreno" value={land} onChange={(e) => setLand(e.target.value)} />
                </FloatingLabel>

                <FloatingLabel label="Construcción ( m2 )" className="mb-3">
                  <Form.Control disabled={signed ? false : true} type="text" placeholder="Construcción" value={build} onChange={(e) => setBuild(e.target.value)} />
                </FloatingLabel>

                {offer === 'venta' &&
                  <FloatingLabel label="Fecha de entrega estimada" className="mb-3">
                    <Form.Control disabled={signed ? false : true} type="text" placeholder="Fecha de entrega estimada" value={delivery} onChange={(e) => setDelivery(e.target.value)} />
                  </FloatingLabel>
                }

                {offer === 'renta' &&
                  <FloatingLabel label="Precio Renta X M2" className="mb-3">
                    <Form.Control disabled={signed ? false : true} type="text" placeholder="Precio de Renta x M2" value={priceRent} onChange={(e) => setPriceRent(e.target.value)} />
                  </FloatingLabel>
                }
              </Col>
              {signed &&
                <Col md={12}>
                  <FloatingLabel label="Dueño o Inquilino" className="mb-3">
                    <Form.Control type="text" placeholder="Dueño o Inquilino" value={rent} onChange={(e) => setRent(e.target.value)} />
                  </FloatingLabel>
                </Col>
              }
            </Row>
          </Container>

        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={() => setShow(false)}>Cerrar</Button>
        </Modal.Footer>
      </Modal>

      <Navbar collapseOnSelect bg="light" expand="lg" fixed="top">
        <Container>
          <Navbar.Brand ><a href='/'><img src={logo} height="45px" /></a></Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav" >
            <Nav className="me-auto">
            </Nav>
            <Nav className='align-items-center'>
              <Nav.Link href="/">
                <div style={{ color: "#21283a", fontWeight: 700 }}>Regresar al inicio</div>
              </Nav.Link>
              <Nav.Link onClick={downloading}>
                <div style={{ backgroundColor: "#90bf32", padding: '10px 15px', borderRadius: '15px', color: '#fff', fontWeight: 700 }}>Descargar Plano</div>
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <Container>
        <Row>
          <Col align="center">
            <div className="header-filter">
              {/*<div className="sub-title-green" style={{ marginTop: "0px", fontSize: "50px" }}> Planos de disponibilidad </div>*/}
              <Form.Group className="mb-3">
                <Form.Label >Parque Industrial SPH</Form.Label>
                <Form.Select aria-label="Parque" size="sm" value={park} onChange={(e) => { setPark(e.target.value); setOffer('renta'); }}>
                  <option>Selecciona un Parque</option>
                  <option value="SPARTEK">SPARTEK</option>
                  <option value="SPARTEK III">SPARTEK III</option>
                  <option value="ACUPARK">ACUPARK</option>
                  <option value="ACUPARK II">ACUPARK II</option>
                  <option value="ACUPARK III">ACUPARK III</option>
                  <option value="NORTE">NORPONIENTE</option>
                  <option value="ACTITEK">ACTITEK</option>
                  <option value="SITAPARK">SITAPARK</option>
                </Form.Select>
              </Form.Group>

              <Form.Label >Oferta</Form.Label>
              <Container>
                <Row>
                  <Col>
                    <Form.Check
                      inline
                      label="Renta"
                      name="group1"
                      type='radio'
                      checked={offer == 'renta' ? true : false}
                      onChange={() => setOffer('renta')}
                    />
                    {park !== 'ACUPARK III' && <Form.Check
                      inline
                      label="Venta"
                      name="group1"
                      type='radio'
                      checked={offer == 'venta' ? true : false}
                      onChange={() => setOffer('venta')}
                    />}
                  </Col>
                </Row>
              </Container>
            </div>
          </Col>
        </Row>
      </Container>
      <br />
      <div id="App" className="app-container">
        <div className='map-container'>
          { /*<img src={ header } className='header-style' />*/}
          <div className="header">
            <Container>
              <Row className="align-items-center" style={{ position: 'relative' }}>
                <Col md={3} xs={12} className='nav-style'>
                  <div>
                    <img src={logo_b} className="logo" />
                  </div>
                </Col>
                <Col md={6} xs={12} align="left">
                  <div className="title">
                    PARQUE INDUSTRIAL
                  </div>
                  <div className="title-big">
                    {park == 'NORTE' ? 'NORPONIENTE' : park}
                  </div>
                </Col>
                <Col md={3} xs={12}>
                  <div className='date'>{date}</div>
                  <div className='subtitle'>
                    <div>{offer}</div>
                    <div style={{ fontSize: '10px', fontFamily: 'Rubik', paddingTop: '15px', lineHeight: '15px' }}>Para consultar precios, metraje y fechas de entrega, dar click sobre la nave.</div>
                  </div>
                  <div className='date'> { } </div>
                </Col>
              </Row>
            </Container>
          </div>

          <br /><br />

          <Container style={{ paddingLeft: '30px' }}>
            <Row align="left">
              <Col md={6}>
                <Container>
                  <Row>
                    {offer == 'renta' &&
                      <Col md={'auto'}>
                        <>
                          <span className='circle-softred'></span>&nbsp;&nbsp;&nbsp;
                          <span className="circle-legend">Arrendado</span>
                        </>
                      </Col>
                    }
                    {offer == 'venta' &&
                      <Col md={'auto'}>
                        <span className='circle-softred'></span>&nbsp;&nbsp;&nbsp;
                        <span className="circle-legend">Vendida</span>
                      </Col>
                    }
                    <Col md={'auto'}>
                      {offer == 'renta' && <><span className='circle-green'></span>&nbsp;&nbsp;&nbsp;</>}
                      {offer == 'venta' && <><span className='circle-green'></span>&nbsp;&nbsp;&nbsp;</>}
                      <span className="circle-legend">Disponible</span>
                    </Col>
                    {offer == 'renta' && <>
                      <Col md={'auto'}>
                        <span className='circle-green-b'></span>&nbsp;&nbsp;&nbsp;
                        <span className="circle-legend">Disponible con 80% o más de construcción</span>
                      </Col>
                      <Col md={'auto'}>
                        <span className='circle-green-c'></span>&nbsp;&nbsp;&nbsp;
                        <span className="circle-legend">Disponible con menos del 80% de construcción</span>
                      </Col>
                    </>
                    }
                    <Col md={'auto'}>
                      <span className='circle-blue'></span>&nbsp;&nbsp;&nbsp;
                      <span className="circle-legend">Apartado</span>
                    </Col>
                    <Col md={'auto'}>
                      <span className='circle-gray'></span>&nbsp;&nbsp;&nbsp;
                      <span className="circle-legend">Bloqueado</span>
                    </Col>
                    {offer == 'renta' &&
                      <>
                        <Col md={'auto'}>
                          <span className='circle-orange'></span>&nbsp;&nbsp;&nbsp;
                          <span className="circle-legend">Usuario final</span>
                        </Col>
                        <Col md={'auto'}>
                          <span className='circle-white'></span>&nbsp;&nbsp;&nbsp;
                          <span className="circle-legend">No disponible por construcción</span>
                        </Col>
                      </>
                    }
                  </Row>
                </Container>
              </Col>
              <Col md={6}>
                <Container>
                  <Row>
                    {offer == 'venta' &&
                      <Col md={'auto'}>
                        <span className='circle-yellow'></span>&nbsp;&nbsp;&nbsp;
                        <span className="circle-legend">Arrendado</span>
                      </Col>
                    }
                    <Col md={'auto'}>
                      <span className='circle-land'></span>&nbsp;&nbsp;&nbsp;
                      <span className="circle-legend">Lote industrial</span>
                    </Col>
                    <Col md={'auto'}>
                      <span className='circle-red'></span>&nbsp;&nbsp;&nbsp;
                      <span className="circle-legend">En construcción</span>
                    </Col>
                    <Col md={'auto'}>
                      <span className='circle-lightblue'></span>&nbsp;&nbsp;&nbsp;
                      <span className="circle-legend">Por construir</span>
                    </Col>
                    { /*offer == 'venta' &&
                      <Col md={ 'auto' }> 
                        <span className='squart-red'></span>&nbsp;&nbsp;&nbsp;
                        <span className="circle-legend">Disponible para renta</span>
                      </Col>*/
                    }
                  </Row>
                </Container>
              </Col>
            </Row>
          </Container>

          {park == 'SPARTEK' &&
            <SpartekII />
          }
          {park == 'SPARTEK III' &&
            <SpartekIII />
          }
          {park == 'ACUPARK' &&
            <ACUPARK />
          }
          {park == 'ACUPARK II' &&
            <ACUPARKII />
          }
          {park == 'ACUPARK III' &&
            <ACUPARKIII />
          }
          {park == 'NORTE' &&
            <NORTE />
          }
          {park == 'ACTITEK' &&
            <ACTITEK />
          }
          {park == 'SITAPARK' &&
            <SITAPARK />
          }

          <div className="footer">
            <Container>
              <Row className="align-items-center">
                <Col>
                  <div className='footer-text'>Grupo SPH, Lic. Manuel Gómez Morín, piso 11, oficina 11A, 76090, Centro Sur, Qro.</div>
                </Col>
              </Row>
            </Container>
          </div>

          {/* <Container>
            <Row align="left">
              <Col md={ 4 }> 
                <span className='circle-purple'></span>&nbsp;&nbsp;&nbsp;
                <span className="circle-legend">Vendida y rentada</span>
              </Col>
              <Col md={ 4 }> 
                <span className='circle-orange'></span>&nbsp;&nbsp;&nbsp;
                <span className="circle-legend">Vendida - Disponible para renta</span>
              </Col>
              <Col md={ 4 }> 
                <span className='circle-red'></span>&nbsp;&nbsp;&nbsp;
                <span className="circle-legend">Vendida - No construida</span>
              </Col>
              <Col md={ 4 }> 
                <span className='circle-blue'></span>&nbsp;&nbsp;&nbsp;
                <span className="circle-legend">Disponible para renta</span>
              </Col>
              <Col md={ 4 }> 
                <span className='circle-green'></span>&nbsp;&nbsp;&nbsp;
                <span className="circle-legend">Rentada - Disponible para venta</span>
              </Col>
              <Col md={ 4 }> 
                <span className='circle-yellow'></span>&nbsp;&nbsp;&nbsp;
                <span className="circle-legend">RA y disponible para renta</span>
              </Col>
              <Col md={ 4 }> 
                <span className='circle-brown'></span>&nbsp;&nbsp;&nbsp;
                <span className="circle-legend">RC, RA y disponible para renta</span>
              </Col>
            </Row>
            </Container> */}
        </div>
      </div>

      <br />
      <br />
    </div>
  );
}

export default App;
